import isMobile from "is-mobile"
export function isMobileScreen() {

  
  return isMobile()
}
